"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8-.001 8 8 0 0 0 8 16Zm-.82-9.24v2.56L9.43 8 7.18 6.76Zm4.25-1.58a1.09 1.09 0 0 1 .77.82c.119.66.179 1.33.18 2 .004.7-.056 1.4-.18 2.09a1.11 1.11 0 0 1-.77.77 25.8 25.8 0 0 1-3.37.18 25.87 25.87 0 0 1-3.37-.18 1.09 1.09 0 0 1-.76-.77A11.41 11.41 0 0 1 3.75 8c.001-.67.061-1.34.18-2a1.08 1.08 0 0 1 .76-.77A25.87 25.87 0 0 1 8.06 5a25.79 25.79 0 0 1 3.37.18Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12 24A12 12 0 1 0 12 .001 12 12 0 0 0 12 24Zm-1.23-13.86v3.84L14.145 12l-3.375-1.86Zm6.375-2.37A1.635 1.635 0 0 1 18.3 9c.178.99.268 1.994.27 3 .006 1.051-.084 2.1-.27 3.135a1.666 1.666 0 0 1-1.155 1.155c-1.677.2-3.366.29-5.055.27-1.69.02-3.378-.07-5.055-.27a1.634 1.634 0 0 1-1.14-1.155A17.115 17.115 0 0 1 5.625 12c.002-1.006.092-2.01.27-3a1.62 1.62 0 0 1 1.14-1.155A38.804 38.804 0 0 1 12.09 7.5c1.69-.02 3.378.07 5.055.27Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16 32a16 16 0 1 0 0-32 16 16 0 0 0 0 32Zm-1.64-18.48v5.12l4.5-2.64-4.5-2.48Zm8.5-3.16A2.18 2.18 0 0 1 24.4 12c.237 1.32.358 2.659.36 4a22.82 22.82 0 0 1-.36 4.18 2.22 2.22 0 0 1-1.54 1.54 51.581 51.581 0 0 1-6.74.36 51.739 51.739 0 0 1-6.74-.36 2.18 2.18 0 0 1-1.52-1.54A22.82 22.82 0 0 1 7.5 16a22.82 22.82 0 0 1 .36-4 2.16 2.16 0 0 1 1.52-1.54c2.234-.3 4.486-.454 6.74-.46a51.587 51.587 0 0 1 6.74.36Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24 48a24 24 0 1 0 0-48 24 24 0 0 0 0 48Zm-2.46-27.72v7.68L28.29 24l-6.75-3.72Zm12.75-4.74A3.27 3.27 0 0 1 36.6 18c.356 1.98.537 3.988.54 6a34.235 34.235 0 0 1-.54 6.27 3.33 3.33 0 0 1-2.31 2.31c-3.355.4-6.732.58-10.11.54-3.378.04-6.755-.14-10.11-.54a3.27 3.27 0 0 1-2.28-2.31 34.235 34.235 0 0 1-.54-6.27c.003-2.012.184-4.02.54-6a3.24 3.24 0 0 1 2.28-2.31c3.351-.45 6.729-.68 10.11-.69a77.38 77.38 0 0 1 10.11.54Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32 64a32 32 0 1 0 0-64 32 32 0 0 0 0 64Zm-3.28-36.96v10.24l9-5.28-9-4.96Zm17-6.32A4.36 4.36 0 0 1 48.8 24a45.56 45.56 0 0 1 .72 8 45.64 45.64 0 0 1-.72 8.36 4.44 4.44 0 0 1-3.08 3.08c-4.473.534-8.976.775-13.48.72-4.504.054-9.007-.187-13.48-.72a4.36 4.36 0 0 1-3.04-3.08A45.64 45.64 0 0 1 15 32a45.56 45.56 0 0 1 .72-8 4.32 4.32 0 0 1 3.04-3.08c4.468-.6 8.971-.907 13.48-.92a103.18 103.18 0 0 1 13.48.72Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconYoutube = function IconYoutube(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Youtube' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Youtube"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconYoutube.sizes = [16, 24, 32, 48, 64];
IconYoutube.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconYoutube;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/social/Youtube.js
// module id = 2305
// module chunks = 0